import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../base-component/base.component';
import { ConfirmDialog } from './interfaces/confirm-dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})

export class ConfirmDialogComponent extends BaseComponent {
  dialogData: ConfirmDialog;
  title: string;
  message: string;

  constructor(
    public dialogRef: MatLegacyDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: ConfirmDialog
  ) {
    super();
  }

  onInit(): void {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

}
